import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "datasource-cameras-map__left-bar-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "datasource-cameras-map__left-bar"
}
const _hoisted_3 = { class: "heading-m" }
const _hoisted_4 = { class: "datasource-cameras-map__map" }
const _hoisted_5 = { class: "datasource-cameras-map__bar" }
const _hoisted_6 = { class: "map__button-wrapper" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_8 = { class: "map__button-wrapper" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_10 = { class: "map__button-wrapper" }
const _hoisted_11 = { class: "map__button-wrapper" }
const _hoisted_12 = { class: "map__button-wrapper datasource-cameras-map__search" }
const _hoisted_13 = { class: "map__button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NTable = _resolveComponent("NTable")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_MapProviderSelect = _resolveComponent("MapProviderSelect")!
  const _component_MapAreaSelect = _resolveComponent("MapAreaSelect")!
  const _component_MapSearch = _resolveComponent("MapSearch")!
  const _component_MapZones = _resolveComponent("MapZones")!
  const _component_CameraClusterMarker = _resolveComponent("CameraClusterMarker")!
  const _component_CameraMarker = _resolveComponent("CameraMarker")!
  const _component_Map = _resolveComponent("Map")!
  const _component_DataSourcesCamerasGrid = _resolveComponent("DataSourcesCamerasGrid")!
  const _component_NTooltip = _resolveComponent("NTooltip")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['datasource-cameras-map', { 'datasource-cameras-map_has-left-bar': _ctx.leftBarOn }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.leftBarOn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.sidebarHeaderText), 1),
            _createVNode(_component_NTable, {
              class: "datasource-cameras-map__table",
              columns: _ctx.columns,
              content: _ctx.availableItems,
              selected: _ctx.selectedItems,
              "body-decorators": _ctx.bodyDecorators
            }, null, 8, ["columns", "content", "selected", "body-decorators"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_NButton, {
            icon: _ctx.leftBarOn ? 'arrow-left' : 'left-panel',
            type: "secondary",
            onAction: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leftBarOn = !_ctx.leftBarOn))
          }, null, 8, ["icon"])
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_MapProviderSelect, {
            modelValue: _ctx.providerId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.providerId) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          (_ctx.map)
            ? (_openBlock(), _createBlock(_component_MapAreaSelect, {
                key: 0,
                map: _ctx.map,
                "area-draw-on": _ctx.areaDrawOn,
                "onUpdate:area-draw-on": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.areaDrawOn) = $event)),
                actions: _ctx.areaActions,
                onAction: _ctx.handleAreaAction
              }, null, 8, ["map", "area-draw-on", "actions", "onAction"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_NButton, {
            icon: "camera-track",
            type: _ctx.cameraConesOn ? 'primary' : 'secondary',
            onAction: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cameraConesOn = !_ctx.cameraConesOn))
          }, null, 8, ["type"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_MapSearch, { onSelect: _ctx.handleSearchSelect }, null, 8, ["onSelect"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_MapZones, {
            modelValue: _ctx.currentMapView,
            "onUpdate:modelValue": _ctx.handleViewChanged
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ])
      ]),
      _createVNode(_component_Map, {
        "locate-on": "",
        "store-state": "",
        "provider-id": _ctx.providerId,
        onMapReady: _ctx.handleMapReady
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clusterItems, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.id
            }, [
              (item.is_cluster)
                ? (_openBlock(), _createBlock(_component_CameraClusterMarker, {
                    key: 0,
                    id: item.id,
                    "lat-lng": item.payload.latLng,
                    label: item.payload.point_count_abbreviated,
                    onSelect: (event) => _ctx.handleClusterClick(event, item)
                  }, null, 8, ["id", "lat-lng", "label", "onSelect"]))
                : (_openBlock(), _createBlock(_component_CameraMarker, {
                    key: 1,
                    item: item.payload,
                    "has-cone": _ctx.cameraConesOn,
                    selected: _ctx.selectedItems.includes(item.payload.id),
                    "show-status": this.pageType === 'cameras',
                    opened: _ctx.getIsCameraOpened(item.payload),
                    onClick: () => _ctx.handleCameraClick(item.payload),
                    readonly: ""
                  }, null, 8, ["item", "has-cone", "selected", "show-status", "opened", "onClick"]))
            ], 64))
          }), 128))
        ]),
        _: 1
      }, 8, ["provider-id", "onMapReady"])
    ]),
    (_ctx.popupState.visible)
      ? (_openBlock(), _createBlock(_component_NTooltip, {
          key: 0,
          "auto-placement": "",
          mode: "manual",
          placement: "right",
          "has-view": false,
          "visible-arrow": false,
          reference: _ctx.popupState.reference,
          to: _ctx.popupState.container
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_DataSourcesCamerasGrid, {
              items: _ctx.popupState.items
            }, null, 8, ["items"]), [
              [_directive_click_outside, _ctx.resetPopup]
            ])
          ]),
          _: 1
        }, 8, ["reference", "to"]))
      : _createCommentVNode("", true)
  ], 2))
}